import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import { useState } from 'react';
import { Box, Button, LinearProgress, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import SignedImage from '../aws/SignedImage';
var UploadState;
(function (UploadState) {
    UploadState["Choosing"] = "Choosing";
    UploadState["Confirm"] = "Confirm";
    UploadState["Uploading"] = "Uploading";
    UploadState["Processing"] = "Processing";
    UploadState["Display"] = "Display";
})(UploadState || (UploadState = {}));
/**
 * Child component for displaying the asset or a placeholder.
 */
const AssetDisplay = ({ asset }) => {
    if (!asset) {
        return (_jsx(Box, { children: "No file specified" }));
    }
    console.log(`Displaying asset ${asset.name} with preview url: ${asset.thumb200h}`);
    if (asset.status !== 'processed') {
        return (_jsx(Box, { children: "Asset is being processed" }));
    }
    return (_jsx(Box, { sx: {
            borderRadius: '50%',
            width: '200px',
            height: '200px',
            overflow: 'hidden',
            margin: '0 auto',
        }, children: _jsx(SignedImage, { bucket: asset.repository.bucket, bucketKey: `${asset.path}/thumb200h`, status: asset.status, alt: asset.name }) }));
};
const AssetDisplayObs = observer(AssetDisplay);
/**
 * Widget typically passes through several states:
 * Choosing File -> Uploading -> Uploaded
 * and then once Uploaded, will poll every few seconds to see if
 * Asset is being processed, or if that is complete.
 *
 * @param Repository that is being uploaded to
 * @returns Asset
 */
const UploadViewImage = ({ repository, asset, onAssetChange, uploadPrefix, }) => {
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadState, setUploadState] = useState(UploadState.Display);
    const store = useStore();
    const monitorUploadProgress = (progressPercent) => {
        setUploadProgress(progressPercent);
        if (progressPercent === 100) {
            // setUploadState(UploadState.Processing);
            console.log('Handle completed click');
            setUploadState(UploadState.Display);
        }
    };
    const handleUploadClick = (file) => {
        console.log('Handle upload click');
        if (!file) {
            return;
        }
        setUploadState(UploadState.Uploading);
        // setProgress is a call back - expects a number between 0 and 100.
        store.upload(file, repository, onAssetChange, monitorUploadProgress, true, 'profile', uploadPrefix);
    };
    const handleFileSelected = (event) => {
        handleUploadClick(event.target.files[0]);
    };
    return (_jsxs(Box, { children: [uploadState === UploadState.Display && (_jsxs(Box, { children: [_jsx(AssetDisplayObs, { asset: asset }), _jsxs("label", { htmlFor: "contained-button-file", children: [_jsx("input", { id: "contained-button-file", name: "contained-button-file", accept: "image/*", style: { display: 'none' }, type: "file", onChange: handleFileSelected }), _jsx(Box, { sx: { mt: 2 }, children: _jsx(Button, { component: "span", className: "site-system-button-secondary", children: "Upload" }) })] })] })), uploadState === UploadState.Uploading && (_jsx(Box, { sx: { width: '100%' }, children: _jsx(LinearProgress, { variant: "determinate", value: uploadProgress }) }))] }));
};
export default observer(UploadViewImage);
//# sourceMappingURL=UploadViewImage.js.map